import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b1f50c8&"
import script from "./index.js?vue&type=script&lang=ts&"
export * from "./index.js?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports